import {
  PortalEventService,
  PortalEventServiceGetTicketAvailableConsecutiveCountRequest,
} from "@spwn-portal/grpc";
import useSWR from "swr";

import { useConnectClient } from "../../utility/connectWeb";

import type { SeatPrecheckItem } from "./needsNonConsecutiveConsent";

type ConsecutiveCountClient = {
  getTicketAvailableConsecutiveCount: (req: {
    eventId: string;
    ticketId: string;
  }) => Promise<{ count: number }>;
};

const fetchTicketsAvailableConsecutiveCount = async (
  client: ConsecutiveCountClient,
  items: SeatPrecheckItem[]
): Promise<number[]> =>
  Promise.all(
    items.map(async (item) =>
      client
        .getTicketAvailableConsecutiveCount(
          new PortalEventServiceGetTicketAvailableConsecutiveCountRequest({
            eventId: item.eventId,
            ticketId: item.ticketId,
          })
        )
        .then((r) => r.count)
    )
  );

/** 各座席チケットの連番購入可能数を取得する薄い SWR ラッパー（-1=制約なし）。items が空なら fetch しない。 */
export const useTicketsAvailableConsecutiveCount = (
  items: SeatPrecheckItem[]
): { counts: number[] | undefined; isLoading: boolean } => {
  const client = useConnectClient(PortalEventService);
  const { data, isLoading } = useSWR(
    items.length > 0 ? ["ticketsAvailableConsecutiveCount", items] : null,
    async () => fetchTicketsAvailableConsecutiveCount(client, items)
  );
  return { counts: data, isLoading };
};
